<template>
  <button :class="props.class" @click="likeActivity()">
    <HeartIcon class="w-6 h-6" :class="isLiked ? 'fill-current' : 'fill-none'" />
    <div>{{ showCounter ? selectedPin?.like_id.length : '' }}</div>
  </button>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'

import { usePinsStore } from '@/stores/pins'
import { HeartIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'
import { v4 } from 'uuid'

import { axiosInstance } from '@/utils/axios'

const pinsStore = usePinsStore()
const { updatePin } = pinsStore
const { selectedPin } = storeToRefs(pinsStore)

defineEmits<{
  (e: 'like'): void
}>()

export interface LikeButtonProps {
  class?: string
  showCounter?: boolean
}

const props = withDefaults(defineProps<LikeButtonProps>(), {
  class: 'btn btn-ghost text-accent flex flex-row',
  showCounter: false
})

const idCheck = () => {
  let userId = localStorage.getItem('userId')

  if (!userId) {
    const newId = v4()
    localStorage.setItem('userId', newId)
    userId = newId
  }

  return userId
}

const checkIsLiked = () => {
  const userId = idCheck()
  if (selectedPin.value) {
    isLiked.value = selectedPin.value.like_id.includes(userId)
  }
}

const likeActivity = async () => {
  if (!selectedPin.value) {
    return
  }
  const userId = idCheck()

  const { data } = await axiosInstance.post(`activities/like/${selectedPin.value._id}`, { userId })

  if (data._id === selectedPin.value._id) {
    selectedPin.value = data
    updatePin(data)
  }
  checkIsLiked()
}

const isLiked = ref(false)

onMounted(() => {
  checkIsLiked()
})

watch(selectedPin, () => {
  checkIsLiked()
})
</script>
